import { Services } from '@sigma-frontend-libs/commons'
import { TaskTypes } from '@sigmasms/shared-types'

import sticker from '@/components/sticker'

export default function(h) {
  let borderStyle
  if (this.to) {
    borderStyle = 'solid'
  } else {
    borderStyle = 'dashed'
  }

  return h(
    sticker,
    {
      props: {
        value: this.value.title,
        label: this.getTranslate(`${Services.tasks}.labels.title`),
        copy: true,
        borderStyle,
        readonly: this.value.type !== TaskTypes['payments:recurrent'],
        to: this.to
      }
    }
  )
}
